import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import useRebrandVersion from 'hooks/useRebrandVersion'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

/**
 * Keeps the document palette scope aligned with static brand configuration.
 * Uses a layout effect so the body class matches the theme before paint,
 * matching structural reads of useRebrandVersion() in the same commit.
 */
function usePaletteVersionBodyClass() {
  const rebrandVersion = useRebrandVersion()

  useIsomorphicLayoutEffect(() => {
    document.body.classList.toggle(REBRAND_PALETTE_CLASS, rebrandVersion === 'rebrand')
  }, [rebrandVersion])
}

export default usePaletteVersionBodyClass
